module.exports = __webpack_public_path__ + "img/amazon.70c27023.svg";